import React from "react";

import {
  FaEnvelope,
  FaHeadset,
  FaPhoneAlt,
  FaUser,
} from "react-icons/fa";

export default function TutorialSupportCard({
  support,
}) {
  if (!support) {
    return null;
  }

  const phoneHref =
    support.phone
      ? `tel:${support.phone.replace(
          /[^\d+]/g,
          ""
        )}`
      : null;

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-800 bg-slate-950 text-white shadow-xl">
      <div className="relative p-6 sm:p-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(14,165,233,0.28),transparent_34%),radial-gradient(circle_at_bottom_left,rgba(124,58,237,0.30),transparent_38%)]" />

        <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[20px] bg-white/10 text-xl text-sky-300">
              <FaHeadset />
            </div>

            <div>
              <h2 className="text-xl font-bold">
                {support.title ||
                  "Besoin d’aide ?"}
              </h2>

              <p className="mt-2 max-w-xl text-sm leading-6 text-slate-300">
                {support.description}
              </p>

              {support.name ? (
                <div className="mt-3 flex items-center gap-2 text-sm font-semibold text-white">
                  <FaUser className="text-sky-300" />
                  {support.name}
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">
            {support.email ? (
              <a
                href={`mailto:${support.email}`}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-5 py-3 text-sm font-semibold text-slate-950 transition hover:bg-sky-100"
              >
                <FaEnvelope />
                Envoyer un email
              </a>
            ) : null}

            {phoneHref ? (
              <a
                href={phoneHref}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/20"
              >
                <FaPhoneAlt />
                {support.phone}
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}